export default __webpack_public_path__ + "static/media/a019-tip-en.03c21784.jpg";